import React, { useState } from "react";
// react component for creating dynamic tables
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ReactBSAlert from "react-bootstrap-sweetalert";
import { useHistory } from "react-router-dom";
import ToolkitProvider, {
  Search,
  CSVExport,
} from "react-bootstrap-table2-toolkit";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import DatePicker from "react-datepicker";
// @material-ui/lab components
// @material-ui/icons components
// core components
import Snackbar from "components/Snackbar/Snackbar.js";
import componentStyles from "assets/theme/views/admin/react-bs-table.js";
import btnComponentStyles from "assets/theme/components/button.js";
import LoadingAnimation from "components/Animations/loading";
import Slide from "@material-ui/core/Slide";
import Tooltip from "@material-ui/core/Tooltip";
import { useAsyncEffect } from "use-async-effect";
import { ArrowBack } from "@material-ui/icons";

import {
  getBagWeightReport
} from "../../network/ApiAxios";
import { redirectToLogout,dateSortFunc,
 numericSortFunc
 } from "common/SharedFn";


const useStyles = makeStyles(componentStyles);
const useStylesButtons = makeStyles(btnComponentStyles);
const createHistory = require("history").createBrowserHistory;

const pagination = paginationFactory({
  page: 1,
  alwaysShowAllBtns: true,
  showTotal: true,
  withFirstAndLast: false,
  sizePerPage:50,
  sizePerPageRenderer: ({ onSizePerPageChange }) => (
    <div className="dataTables_length" id="datatable-basic_length">
      <label>
        Show{" "}
        {
          <select
            name="datatable-basic_length"
            aria-controls="datatable-basic"
            className="form-control form-control-sm"
            onChange={(e) => onSizePerPageChange(e.target.value)}
          >
            <option value="50">50</option>
            <option value="100">100</option>
            <option value="500">500</option>
            <option value="1000">1000</option>
          </select>
        }{" "}
        entries.
      </label>
    </div>
  ),
});

const { SearchBar } = Search;

const { ExportCSVButton } = CSVExport;

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const BagWeightTable = (props) => {
  const classes = { ...useStyles(), ...useStylesButtons() };
  const [alert, setAlert] = React.useState(false);
  const componentRef = React.useRef(null);
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState("");
  const [notifMessage, setNotifMessage] = useState("");
  const [success, setSuccess] = React.useState(false);
  const [showError, setShowError] = React.useState(false);
  const [option, setOption] = useState(0);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [forceRefresh, setForceRefresh] = useState(false);

  const [ids, setIds] = useState([]);
  const [selectedCount, setSelectedCount] = useState(0);
  let history = useHistory();

  const warningAlert = (title,message,action) => {
    setAlert(
      <ReactBSAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title={title}
        onConfirm={action}
        onCancel={() => setAlert(null)}
        showCancel="true"
        cancelBtnBsStyle="warning"
        cancelBtnText="No"
        confirmBtnBsStyle="success"
        confirmBtnText="Yes"
        btnSize=""
        confirmBtnStyle={{
          marginRight: undefined,
          borderColor: undefined,
          boxShadow: undefined,
        }}
        cancelBtnStyle={{
          marginRight: undefined,
          borderColor: undefined,
          boxShadow: undefined,
        }}
      >
        {message}
      </ReactBSAlert>
    );
  };

  const showSuccessNotification = (message) => {
    setNotifMessage(message);
    setSuccess(true);
    setTimeout(function () {
      setSuccess(false);
    }, 3000);
  };

  const showErrorNotification = (message) => {
    setNotifMessage(message);
    setShowError(true);
    setTimeout(function () {
      setShowError(false);
    }, 3000);
  };

  const fetchBagWeight = async () => {
    setForceRefresh(false);
    setIsLoading(true);
    setData([]);
    try {
      const response = await getBagWeightReport(startDate, endDate);
      const { data } = response;
      if (data.result.isSuccess) {
        setData(data.data.map((prop) => makeTableRow(prop)));
        //setError("");
      } else {
        showErrorNotification(data.result.description);
        if (data.result.code == -2) {
          redirectToLogout();
        }
      }
    } catch (ex) {
      showErrorNotification("Failed to fetch records "+ex);
    }
    setIsLoading(false);
  };

  useAsyncEffect(async () => {
    
    if (endDate == null) {
      var endDateStored = localStorage.getItem("searchEndDate");
      if(endDateStored != null && endDateStored.toUpperCase() !== "NULL"){
        setEndDate(new Date(endDateStored));
      }
      else{
        setEndDate(new Date());
      }
    }
    if (startDate == null) {
      var startDateStored = localStorage.getItem("searchStartDate");
      if(startDateStored != null && startDateStored.toUpperCase() !== "NULL"){
        setStartDate(new Date(startDateStored));
      }
      else{
        setStartDate(new Date().setDate(new Date().getDate() - 7));
      }
    }
    else if (startDate != null && endDate != null) {
        fetchBagWeight();
      }
  }, [
    forceRefresh,
    startDate,
    endDate,
    option
  ]);

  const makeTableRow = (info) => {
    return {
      ...info,
    };
  };

  return (
    <>
      {alert}
      {/* Page content */}
      <Container
        maxWidth={false}
        component={Box}
        marginTop="-4.5rem"
        classes={{ root: classes.containerRoot }}
      >
        <Grid container>
          <Grid item xs={12}>
            <Card elevation={0}>
              <CardHeader
                subheader={
                  <>
                  <Tooltip title="Back">
                        <Button
                          size="small"
                          classes={{
                            root: classes.buttonContainedPrimary,
                          }}
                          variant="contained"
                          style={{ marginRight: "20px" }}
                          onClick={() => {
                            history.goBack();
                          }}
                        >
                          <Box component={ArrowBack} />
                        </Button>
                      </Tooltip>
                    <Box
                      component={Typography}
                      variant="h2"
                      marginBottom="0!important"
                      style={{
                        display: "inline-block",
                      }}
                    >
                      <Box component="span">Bags Weight Report</Box>
                    </Box>
                  </>
                }
                classes={{ root: classes.cardHeaderRoot }}
              ></CardHeader>

              <ToolkitProvider
                data={data}
                keyField="id"
                columns={[
                  {
                    dataField: "publicId",
                    text: "ID",
                    sort: true,
                  },
                  {
                    dataField: "bagType",
                    text: "Bag Type",
                    sort: true,
                  },
                  {
                    dataField: "taggedOnFormatted",
                    text: "Tagged On",
                    sort: true, 
                    sortFunc: dateSortFunc,                    
                  },
                  {
                    dataField: "weight",
                    text: "Weight (KG)",
                    sort: true,
                    sortFunc: numericSortFunc,
                  }]}
                search
                exportCSV
              >
                {(props) => (
                  <div className="py-4 table-responsive">
                    <Grid container className="pl-4">
                      <Grid
                        item
                        xs={12}
                        sm={6}
                        style={{ marginBottom: "15px" }}
                      >
                        {/* <Tooltip
                          title="This will copy to your download the table content."
                          style={{ margin: "5px" }}
                        > */}
                        <ExportCSVButton
                          className="MuiButtonBase-root MuiButton-root MuiButton-contained MuiButton-containedSizeSmall MuiButton-sizeSmall"
                          {...props.csvProps}
                        >
                          <span className="MuiButton-label">Download</span>
                        </ExportCSVButton>
                        <Button style={{ display: "none" }}></Button>
                        {/* </Tooltip> */}
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <div
                          id="datatable-basic_filter"
                          className="dataTables_filter px-4 pb-1 float-right"
                        >
                          <label>
                            Search:
                            <SearchBar
                              className="form-control-sm"
                              placeholder=""
                              {...props.searchProps}
                            />
                          </label>
                        </div>
                      </Grid>
                    </Grid>

                    <Grid container className="pl-4">
                      <Grid item xs={12} sm={12}>
                        <form>
                          View by Tagged On Date From &emsp;
                          <div style={{ display: "inline-block" }}>
                            <DatePicker
                              timeCaption="Start Date"
                              selected={startDate}
                              customInput={<OutlinedInput />}
                              onChange={(date) => {
                                localStorage.setItem("searchStartDate", date);
                                setStartDate(date);}}
                              dateFormat="dd-MM-yyyy"
                            />
                          </div>{" "}
                          &emsp; to &emsp;
                          <div style={{ display: "inline-block" }}>
                            <DatePicker
                              timeCaption="End Date"
                              selected={endDate}
                              customInput={<OutlinedInput />}
                              onChange={(date) => {
                              localStorage.setItem("searchEndDate", date);
                                setEndDate(date);
                              }}
                              dateFormat="dd-MM-yyyy"
                            />
                          </div>{" "}
                        </form>
                      </Grid>
                    </Grid>
                    <Grid container className="pl-4">
                      <Grid item xs={12} sm={12}>
                        <div
                            style={{
                              marginBottom: "20px",
                            }}
                          >
                        </div>
                      </Grid>
                    </Grid>
                    <BootstrapTable
                      ref={componentRef}
                      {...props.baseProps}
                      bootstrap4={true}
                      pagination={pagination}
                      bordered={true}
                      striped={true}
                      // selectRow={selectRow}
                      noDataIndication={() =>
                        isLoading ? (
                          <Box
                            component={Grid}
                            container
                            justifyContent="center"
                            className="justify-content-center"
                          >
                            <div
                              className="text-center"
                              style={{ width: "20%" }}
                            >
                              <LoadingAnimation />{" "}
                            </div>
                          </Box>
                        ) : (
                          <h4>No Records</h4>
                        )
                      }
                      id="main-table"
                    />
                  </div>
                )}
              </ToolkitProvider>
            </Card>
          </Grid>
        </Grid>
        <Snackbar
          place="tr"
          color="success"
          // icon={AddAlert}
          message={notifMessage}
          open={success}
          closeNotification={() => setSuccess(false)}
          close
        />

        <Snackbar
          place="tr"
          color="rose"
          // icon={AddAlert}
          message={notifMessage}
          open={showError}
          closeNotification={() => setShowError(false)}
          close
        />
      </Container>
    </>
  );

};

export default BagWeightTable;
